export const HiddenUsernameField = ({ value }: { value: string }): React.ReactElement => (
  <input
    type="text"
    name="username"
    autoComplete="username"
    value={value}
    readOnly
    className="hidden"
    aria-hidden="true"
  />
);
